import React from 'react';

import { connect } from 'react-redux';

import Flexi12OfferCard from '../../../components/OfferCard/OfferCards/Flexi12OfferCard';
import Flexi24AutoOfferCard from '../../../components/OfferCard/OfferCards/Flexi24AutoOfferCard';
import Flexi24OfferCard from '../../../components/OfferCard/OfferCards/Flexi24OfferCard';
import LightningLoanOfferCard from '../../../components/OfferCard/OfferCards/LightningLoanOfferCard';
import RBLOfferCard from '../../../components/OfferCard/OfferCards/RBLOfferCard';
import { OffersHeading } from '../../../components/OfferCard/OffersHeading';
import { SELECT_OFFER } from '../Offers.actions';

// TODO: Infer types from reducer
const mapStateToProps = (state: any) => ({
    offers: state.offers.offers,
    ready: state.offers.ready,
    isPartnerCustomer: state.offers.isPartnerCustomer
});

const mapDispatchToProps = (dispatch: any) => ({
    selectOffer: (offer_id: string, offer_type: string, product_type: string) =>
        dispatch({
            type: SELECT_OFFER,
            payload: { offer_id, offer_type, product_type }
        })
});

type TOffers = {
    ready: boolean;
    offers: {
        amount: string;
        interestRate: string;
        offerId: string;
        offerType: string;
        productType: string;
        showProbabilityOfOffer: boolean;
        feePercentage: number;
        sweep: {
            min: string;
            max: string;
        };
    }[];

    isPartnerCustomer: boolean;
    selectOffer: (
        offer_id: string,
        offer_type: string,
        product_type: string
    ) => void;
};

const Offers = ({ ready, offers, selectOffer, isPartnerCustomer }: TOffers) => {
    if (!ready) return null;

    const otherOfferTitle = 'Other iwoca options';
    const otherOfferSubtitle =
        'No matter which loan you choose, you can repay early for free and have your own account manager';

    return (
        <div data-testid="offers">
            {offers.length > 1 && (
                <OffersHeading
                    title="Proceed with an offer that's best for you"
                    subtitle="Here is the option we suggest, but there are other options you can choose from"
                />
            )}
            {offers.map(
                (
                    {
                        amount,

                        interestRate,
                        offerId,
                        offerType,
                        productType,
                        showProbabilityOfOffer,
                        sweep,
                        feePercentage
                    },
                    index
                ) => {
                    const onSelect = () => {
                        selectOffer(offerId, offerType, productType);
                    };

                    if (productType === 'rbl')
                        return (
                            <React.Fragment key={offerId}>
                                {index === 1 && (
                                    <OffersHeading
                                        title={otherOfferTitle}
                                        subtitle={otherOfferSubtitle}
                                    />
                                )}
                                <RBLOfferCard
                                    onSelect={onSelect}
                                    amount={amount}
                                    isPartnerCustomer={isPartnerCustomer}
                                    offerType={offerType}
                                    sweep={sweep}
                                />
                            </React.Fragment>
                        );

                    if (productType === 'lightning')
                        return (
                            <React.Fragment key={offerId}>
                                {index === 1 && (
                                    <OffersHeading
                                        title={otherOfferTitle}
                                        subtitle={otherOfferSubtitle}
                                    />
                                )}
                                <LightningLoanOfferCard
                                    onSelect={onSelect}
                                    amount={amount}
                                    interestRate={interestRate}
                                    isPartnerCustomer={isPartnerCustomer}
                                />
                            </React.Fragment>
                        );

                    if (
                        productType === 'flexi12' ||
                        productType === 'lightningBlocked'
                    )
                        return (
                            <React.Fragment key={offerId}>
                                {index === 1 && (
                                    <OffersHeading
                                        title={otherOfferTitle}
                                        subtitle={otherOfferSubtitle}
                                    />
                                )}
                                <Flexi12OfferCard
                                    onSelect={onSelect}
                                    noDocRequirements={
                                        productType === 'lightningBlocked'
                                    }
                                    amount={amount}
                                    isPartnerCustomer={isPartnerCustomer}
                                    showProbabilityOfOffer={
                                        showProbabilityOfOffer
                                    }
                                    offerType={offerType}
                                />
                            </React.Fragment>
                        );

                    if (
                        productType === 'flexi24' ||
                        productType === 'flexi24AutoBlocked'
                    )
                        return (
                            <React.Fragment key={offerId}>
                                {index === 1 && (
                                    <OffersHeading
                                        title={otherOfferTitle}
                                        subtitle={otherOfferSubtitle}
                                    />
                                )}
                                <Flexi24OfferCard
                                    onSelect={onSelect}
                                    amount={amount}
                                    noDocRequirements={
                                        productType === 'flexi24AutoBlocked'
                                    }
                                    isPartnerCustomer={isPartnerCustomer}
                                    showProbabilityOfOffer={
                                        showProbabilityOfOffer
                                    }
                                    offerType={offerType}
                                />
                            </React.Fragment>
                        );

                    if (productType === 'flexi24Auto')
                        return (
                            <React.Fragment key={offerId}>
                                {index === 1 && (
                                    <OffersHeading
                                        title={otherOfferTitle}
                                        subtitle={otherOfferSubtitle}
                                    />
                                )}
                                <Flexi24AutoOfferCard
                                    onSelect={onSelect}
                                    amount={amount}
                                    interestRate={interestRate}
                                    isPartnerCustomer={isPartnerCustomer}
                                    feePercentage={feePercentage}
                                />
                            </React.Fragment>
                        );

                    return null;
                }
            )}
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
